import React, { useState, useEffect} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from './apiConfig';
import { getStatusMessage } from './statusMessages';
import './Signup.css'; // Custom CSS for animation 
import { useAuth } from "./AuthContext";


import axios from 'axios';

function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email,rotp } = location.state || {};

  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const [animateArrow, setAnimateArrow] = useState(false);

  const { login} = useAuth();
  



  // 🔐 Redirect if email is not passed
  useEffect(() => {

    if (!email) {
      navigate('/signup', { replace: true });
    }




  }, [email, navigate]);

  const validateOtp = (value) => {
    const trimmed = value.trim();
    if (trimmed.length !== 6) return 'OTP should be 6 characters.';
    if (!/^[\x20-\x7E]*$/.test(trimmed)) return 'OTP contains invalid characters.';
    return '';
  };

  const validateDevice = (value) => {
    const trimmed = value.trim();
    if (trimmed.length < 2 || trimmed.length > 12) return 'Device should be 2 to 12 characters.';
    return '';
  };

  const handleChangeEmail = () => {
    navigate('/signup');
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setAnimateArrow(true);
    setErrors([]);
    setMessage('');
    setLoading(true);

    const otpError = validateOtp(otp);
    const device = 'web';
    const deviceError = validateDevice(device);

    if (otpError || deviceError) {
      setErrors([otpError, deviceError].filter(Boolean));
      setLoading(false);
     
       setTimeout(() => setAnimateArrow(false), 1000);
       
      return;
    }

    try {
      const res = await axios.post(API_ENDPOINTS.VERIFY_OTP, {
        email,
        OTP: otp,
        device,
      });

 

      const { result, user, opt, token, errors: serverErrors } = res.data;

      if (result === 1) {
        const otpMsg = getStatusMessage(opt)
        setMessage(otpMsg)
        login(token)
        navigate('/Details')
      } else {
        const allMessages = [];

        if (Array.isArray(serverErrors)) {
          allMessages.push(...serverErrors);
        }
        if (user !== undefined) {
          allMessages.push(getStatusMessage(user));
        }
        if (opt !== undefined) {
          allMessages.push(getStatusMessage(opt));
        }

        setErrors(allMessages.length ? allMessages : ['Verification failed.']);
      }
    } catch (err) {
      const status = err.response?.status;
      const data = err.response?.data;

      if (status === 400 && Array.isArray(data?.errors)) {
        setErrors(data.errors);
      } else if (status === 400 && (data?.user || data?.opt)) {
        const failMessages = [];
        // if (data.user !== undefined) failMessages.push(getStatusMessage(data.user));
        if (data.opt !== undefined) failMessages.push(getStatusMessage(data.opt));
        setErrors(failMessages);
      } else {
        setErrors(['Server error. Please try again later.']);
      }
    } finally {
      setLoading(false);
        setTimeout(() => setAnimateArrow(false), 1000);

    }
  };

  return (
    <div
    style={{
      maxWidth: '480px',
      width: '100%',
      margin: '0 auto',
      boxSizing: 'border-box',
        paddingTop: '2rem',
    }}
  >

    
    
      <div style={{ maxWidth: 480, width: '100%', margin: '0 auto' }}>
        <h6 className="text-center wedding-heading">
         <span className="badge bg-secondary">Step 2 of 4</span>
        </h6>

  

  <div
    className="alert text-center mb-4"
    style={{
      backgroundColor: '#e6f0ff', // Lighter blue for inner alert box
      color: '#003366', // Darker text
      borderRadius: '12px',
      padding: '12px',
      fontSize: '1rem',
      border: '1px solid #cce0ff',
    }}
  >
    Verifying: <strong>{email}</strong>
    <br />
    {rotp && (
      <div className="mt-2" style={{ fontSize: '0.95rem' }}>
        {getStatusMessage(rotp)}
      </div>
    )}
  
<button
  className="btn w-100 mt-3 d-flex align-items-center justify-content-start gap-2"
  style={{
    backgroundColor: '#007bff', // Bootstrap primary blue
    color: 'white',
    fontWeight: '500',
    paddingLeft: '1rem'
  }}
  onClick={handleChangeEmail}
>
  <i className="bi bi-arrow-left-circle-fill" style={{ fontSize: '1.3rem' }}></i>
  <span>Change Email</span>
</button>



  </div>




        <form onSubmit={handleVerify}>
          <div className="mb-3">
            <label className="form-label text-muted">Enter OTP</label>
            <input
              type="text"
              className="form-control"
              placeholder="6-digit code"
              maxLength={6}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              autoComplete="one-time-code"
            />
          </div>

     
  


     <button
        type="submit"
        className="btn w-100 mt-3 d-flex justify-content-between align-items-center px-3"
        style={{ backgroundColor: '#ff69b4', color: 'white', overflow: 'hidden' }}
        disabled={loading}
      >
        <span>{loading ? 'Verifying...' : 'Verify OTP'}</span>

        <i
          className={`bi bi-arrow-right-circle-fill ${
            animateArrow ? 'move-arrow' : ''
          }`}
          style={{ fontSize: '1.4rem' }}
        ></i>
      </button>


        </form>

        {message && (
          <div className="alert alert-success mt-3" style={{ whiteSpace: 'pre-line' }}>
            {message}
          </div>
        )}

        {errors.length > 0 && (
          <div className="alert alert-danger mt-3" style={{ backgroundColor: '#ffe0e0', color: '#cc0000' }}>
            <ul className="mb-0">{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyOtp;
